module.exports = __webpack_public_path__ + "img/default-google-maps-lincoln.686cdc8d.png";